var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"list",staticClass:"list"},[_c('ul',{style:(_vm.ulStyle)},_vm._l((_vm.column),function(item,index){return _c('li',{key:'item' + index},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }